// Featured Promotion Section - Scroll Animations
document.addEventListener('DOMContentLoaded', function() {
  // Check if IntersectionObserver is supported
  if ('IntersectionObserver' in window) {
    // Select all promotion cards
    const promotionCards = document.querySelectorAll('.promotion--card');
    
    // Create observer for fade-in animation
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    
    const observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add animation class when card comes into view
          entry.target.style.opacity = '1';
          entry.target.style.animation = 'fadeInUp 0.6s ease forwards';
          
          // Stop observing this element
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // Start observing each card
    promotionCards.forEach((card, index) => {
      // Set initial state
      card.style.opacity = '0';
      card.style.animationDelay = `${(index + 1) * 0.1}s`;
      
      // Start observing
      observer.observe(card);
    });
    
    // Add hover effect for touch devices
    promotionCards.forEach(card => {
      card.addEventListener('touchstart', function() {
        this.classList.add('touch-hover');
      });
      
      card.addEventListener('touchend', function() {
        setTimeout(() => {
          this.classList.remove('touch-hover');
        }, 300);
      });
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    const promotionCards = document.querySelectorAll('.promotion--card');
    promotionCards.forEach(card => {
      card.style.opacity = '1';
    });
  }
  
  // Removed parallax effect - was too distracting
});